import React from "react";
import OneImmoMark from "./OneImmoMark";

export default function SidebarBrand() {
  return (
    <div className="sidebar-brand" aria-label="One.immo Fleet">
      <OneImmoMark size={56} bg="#ffffff" withImmo />
      <span className="sidebar-brand__divider" aria-hidden="true" />
      <div className="sidebar-brand__text">
        <span className="sidebar-brand__eyebrow">One.immo</span>
        <span className="sidebar-brand__word">Fleet</span>
      </div>
    </div>
  );
}
